import { render } from "./Live.vue?vue&type=template&id=864f06a4&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"

import "./Live.vue?vue&type=style&index=0&id=864f06a4&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/外网-四川职业技术学院门户-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864f06a4"]])

export default __exports__